module.exports = __webpack_public_path__ + "static/media/loading-clip-alt.ca46e53d.gif";